import dayjs from 'dayjs'

import { Separator } from '@/components/separator/separator'

import { type VisaBulletinDate } from '@/lib/types/visa-bulletin'
import { cn } from '@/lib/utils'
import { getLocalDate } from '@/lib/utils/datetime'

export type VisaBulletinInfoBoxProps = {
  bulletinDate: string
  filingDate: VisaBulletinDate
  finalActionDate: VisaBulletinDate
  priorityDate?: dayjs.Dayjs
}

export const VisaBulletinInfoBox = ({
  bulletinDate,
  filingDate,
  finalActionDate,
  priorityDate,
}: VisaBulletinInfoBoxProps) => {
  const bulletinDateObj = dayjs(getLocalDate(bulletinDate))
  const bulletinDateMonth = bulletinDateObj?.format('MMM') ?? 'N/A'
  const bulletinDateMonthName = bulletinDateObj?.format('MMMM') ?? 'N/A'
  const bulletinDateYear = bulletinDateObj?.format('YYYY') ?? 'N/A'

  return (
    <div className={cn('w-full', 'p-5', 'rounded-[9px]', 'bg-elevated')}>
      {/* Priority date */}
      <div
        className={cn(
          'w-fit',
          'text-xs font-medium leading-5 text-white',
          'bg-[#2d2d2d]',
          'rounded-[6px]',
          'px-2 py-1.5'
        )}
      >
        Priority Date : {priorityDate?.format('MMM DD, YYYY') ?? 'N/A'}
      </div>

      <div className={cn('mt-3.5', 'text-sm font-medium leading-[18px]')}>
        Visa Bulletin for {bulletinDateMonth} {bulletinDateYear}
      </div>

      <Separator className={cn('my-2.5')} />

      {finalActionDate && filingDate ? (
        <div className={cn('grid grid-cols-2 gap-2')}>
          <div className={cn('flex flex-col gap-y-1.5')}>
            <DateLabel label="Final Action Date" />
            <DateValue date={finalActionDate} />
          </div>
          <div className={cn('flex flex-col gap-y-1.5')}>
            <DateLabel label="Date for Filing" />
            <DateValue date={filingDate} />
          </div>
        </div>
      ) : (
        <p className={cn('text-base font-normal text-red-600')}>
          The {bulletinDateMonthName} Visa Bulletin has not been released yet.
        </p>
      )}
    </div>
  )
}

const DateLabel = ({ label }: { label: string }) => {
  return <p className={cn('text-xs font-normal leading-[18px] text-[#777]')}>{label}</p>
}

const DateValue = ({ date }: { date: VisaBulletinDate }) => {
  return (
    <p className={cn('text-base font-bold text-[#0b0b0b]', 'mt-auto')}>
      {date === 'current'
        ? 'Current'
        : date === 'unauthorized'
          ? 'Unavailable'
          : (date?.format('MMM DD, YYYY') ?? 'N/A')}
    </p>
  )
}
